import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    API: {
      UPDATE_INDUSTRY_ROLE: apiResourceActionCreator('industryRole')
    }
  }
})

export const apiAction = (authToken, industryUser) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.Industries, industryUser.id), authToken, industryUser, actions.user.api.updateIndustryRole)

const configuration = {
  name: 'updateIndustryRole',
  action: actions,
  sagas: undefined,
  reducers: {
    success: (state, { payload: { industryRole } }) => ({
      ...state,
      currentUserIndustryRoles: fp.concat(
        fp.filter(x => x.id !== industryRole.id)(state.currentUserIndustryRoles),
        industryRole
      )
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/updateIndustryRole.js